package com.essntl.core.whatsapp.domain

import com.essntl.core.whatsapp.domain.models.*
import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.message.domain.model.WhapiMessageModel

interface WhatsappClient {
    suspend fun sendMessage(template: WhatsappTemplateData): Result<Unit>
    suspend fun sendWhatsappMessage(template: WhatsappTextMessageData): Result<WhatsappResponse>
    suspend fun getWhapiChats(page: Long, count: Int = 20): Result<List<WhapiChatModel>>
    suspend fun getWhapiChatById(chatId: String): Result<WhapiChatModel>
    suspend fun getWhapiChatMessages(chatId: String): Result<List<WhapiMessageModel>>
    suspend fun sendWhapiTextMessages(message: WhapiTextMessageTemplate): Result<WhapiMessageModel>
    suspend fun updateWhapiChat(chatId: String, chatTemplate: WhapiChatTemplate): Result<Unit>
    suspend fun createWhapiGroup(groupTemplate: WhapiGroupTemplate): Result<WhapiChatModel>
    suspend fun getWhapiGroups(): Result<List<WhapiChatModel>>
    suspend fun getWhapiGroupById(groupId: String): Result<WhapiChatModel>
    suspend fun getWhapiMessageById(whapiId: String): Result<WhapiMessageModel>
    suspend fun reactToMessage(messageId: String, emoji: String): Result<Unit>
    suspend fun checkContact(contactId: String): Result<Unit>
    suspend fun sendContact(to: String): Result<Unit>
    suspend fun updateGroupDescription(groupId: String, description: String): Result<Unit>
    suspend fun addContactToGroup(groupId: String, participants: Set<String>): Result<Unit>
    suspend fun removeContactFromGroup(groupId: String, participants: Set<String>): Result<Unit>
}